// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xK58k","wrapper":"styles_wrapper__4r+4o","languages":"styles_languages__KWFXU","company":"styles_company__Kyt6o"};